export default __webpack_public_path__ + "static/media/english-to-greek-screenshot-06.34815916.png";